import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { publicRoutes } from 'routes'

import { Layout } from './Components/index'
import NotFound from 'Pages/NotFound'
import 'Styles/main.scss'

export default class App extends React.Component {
	render() {
		return (
			<Router>
				<Layout>
					<Switch>
						{publicRoutes.map((route, index) => (
							<Route exact path={route.route} component={route.component} key={index} />
						))}
						<Route exact component={NotFound} />
					</Switch>
				</Layout>
			</Router>
		)
	}
}
